<template>
  <scroll-center-dialog v-model="opened" @close="close" @apply="save" :title="'Перенести записи с интервала'" :scrolled="false" :disabled="isSelect">
    <v-card-text>
      <v-alert type="error" v-if="hasError('intervals')">
        {{ getError('intervals') }}
      </v-alert>
      <v-date-picker
          ref="calendar"
          v-model="day"
          :allowed-dates="allowedDates"
          :first-day-of-week="1"
          :landscape="true"
          :weekdays="{ text: 'Пон - Воскр', value: [1, 2, 3, 4, 5, 6, 0] }"
          class="mt-4"
          clearable
          full-width
          @update:picker-date="changeMonth"
      ></v-date-picker>
      <div v-if="intervals.length > 0" class="py-4">
        <v-autocomplete
            v-model="interval"
            :item-text=dateInterval
            :items="intervals"
            outlined
            item-value="id"
            label="Время записи"
            :item-disabled="(val)=>{return  !val.allow}"
        >
        </v-autocomplete>
        <v-checkbox v-model="deleteInterval"
          label="Удалять интервал после переноса">
        </v-checkbox>
      </div>
      <v-alert type="error" v-if="hasError('detail')">
        {{ getError('detail') }}
      </v-alert>
      <v-alert type="error" v-if="hasError('error')">
        {{ getError('error') }}
      </v-alert>
    </v-card-text>
  </scroll-center-dialog>
</template>

<script>
import urls from '@/urls/helper.js'
import {loadData, makeGetRequest, makePostRequest} from "@/helper/requests";
import {generateListUidToName} from "@/helper/uidToName";
import selectors from "@/urls/selectors";
import LoadingAutocomplete from "@/modules/templates/LoadingAutocomplete.vue";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog.vue";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";
import {mapActions} from "vuex";

export default {
  name: "Role",
  mixins: [FormErrorsMixin],
  components: {LoadingAutocomplete, ScrollCenterDialog},
  props: {
    opened: Boolean,
    docs_data: Object,
  },
  data() {
    return {
      monthDay: [],
      intervals: [],
      day:null,
      deleteInterval:false,
      interval:null,
      value: {
        id: this.id || undefined,
      },
      selectors: {
        event: [],
      },
    }
  },
  watch: {
    'day': function (val) {
      this.loadInterval()
    }
  },
  computed: {
    isSelect() {
      if (this.day &&  this.interval)
        return false
      return true
    },
  },
  methods: {
    ...mapActions({
      loadRecordsTransfer: 'intervals/loadRecordsTransfer',
    }),
    allowedDates(val) {
      let allow = this.monthDay.find((value => {
        return (value.day === val) && (value.allow)
      }))
      return allow
    },
    dateInterval(val) {
      let full =''
      if (!val.allow)
        full ='(запись закрыта)'
      return val.started + " - " + val.ended + " " +full
    },
    changeMonth(event) {
      event = event.split('-');
      let month = parseInt(event[1]);
      let year = parseInt(event[0]);
      this.loadDates(month, year)
    },
    loadInterval() {
      this.interval = null
      let allow = this.monthDay.find((value => {
        return (value.day === this.day) && (value.allow)
      }))
      if (allow) {
        loadData(
            urls.getRecordingUrlWithParameters('selector|date|intervals', 'get', {day: allow.day, event: this.$route.params.event,}),
            (data) => {
              this.intervals = data
            }
        )
      } else {
        this.intervals = []
      }

    },
    loadDates(month = undefined, year = undefined) {
      loadData(
          urls.getRecordingUrlWithParameters('selector|event|dates', 'get', {
            event: this.$route.params.event,
            month: month,
            year: year
          },{vaccinated:0}),
          (data) => {
            this.monthDay = data
            this.day = null
          }
      )
    },
    save() {
      // let idday = this.monthDay.find((value => {
      //   return (value.day === this.day)
      // }))
      let send = {date : this.day,
        'delete': this.deleteInterval,
        interval: this.interval}
      this.loadRecordsTransfer({
        data:send,
        date:this.$route.params.date,
        id:this.docs_data.id,
        finalizer: (data, url) => {
          this.$emit('close', true)
        },
        catcher: (data, url) => {
          this.errors.fields = data
        }
      })
    },
    close() {
      this.$emit('close', false)
    },


  },
  created() {
    // this.loaders.responsible.handler();

    // if (this.docs_data.id) {
    //   this.detailData({
    //     id: this.docs_data.id,
    //     finalizer: (val) => {
    //       this.value = JSON.parse(JSON.stringify(val))
    //     },
    //     catcher: (val) => {
    //       this.mapErrors(val)
    //     },
    //   })
    // }
  }
}
</script>

<style scoped>
</style>
